const firebaseConfig={
    apiKey: "AIzaSyApXvoPv4ZH0oGGh7Hs55pWCYWN7QsUKvc",
    authDomain: "tourplanner-4f494.firebaseapp.com",
    projectId: "tourplanner-4f494",
    storageBucket: "tourplanner-4f494.appspot.com",
    messagingSenderId: "133930743905",
    appId: "1:133930743905:web:82a9d11305753fcc2cd220"
}

export default firebaseConfig;